// extracted by mini-css-extract-plugin
module.exports = {"form":"giphySearch_form__2hDPE","gifSet":"giphySearch_gifSet__pLIFb","gifTile":"giphySearch_gifTile__1oNpI"};